module.exports = __webpack_public_path__ + "static/img/img.ab04622.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contactus/img.png
// module id = M9VY
// module chunks = 1